import { Injectable } from "@angular/core";

import { WetlandSearchCriteria } from "@models/WetlandSearchCriteria";

import { PlantsService } from "./plants.service";

@Injectable()
export class WetlandSearchResolver {
  constructor(private ps: PlantsService) {}

  async resolve(): Promise<WetlandSearchCriteria> {
    const criteria = await this.ps.getWetlandSearchCriteria();
    return criteria;
  }
}
